import React from 'react';

const Discover = ({
  width = 60,
  height = 10,
  id,
}: {
  width?: number;
  height?: number;
  id?: string;
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 60 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid={id}
  >
    <path
      d="M3.379.273H.699V9.66h2.68c1.416 0 2.44-.341 3.345-1.075a4.694 4.694 0 0 0 1.706-3.6C8.413 2.201 6.348.273 3.38.273Zm2.15 7.065c-.58.512-1.314.751-2.508.751h-.495V1.878h.495c1.177 0 1.894.204 2.508.75.631.564 1.007 1.434 1.007 2.338 0 .905-.376 1.81-1.007 2.372ZM11.092.273H9.268V9.66h1.825V.273ZM15.563 3.874c-1.092-.41-1.417-.682-1.417-1.177 0-.598.58-1.041 1.366-1.041.546 0 1.006.222 1.467.768l.956-1.246A4.127 4.127 0 0 0 15.17.137c-1.655 0-2.935 1.16-2.935 2.696 0 1.297.597 1.963 2.304 2.577.717.256 1.075.427 1.263.529.358.239.546.58.546.973 0 .768-.597 1.33-1.417 1.33-.87 0-1.57-.443-1.996-1.245L11.757 8.14c.837 1.246 1.86 1.792 3.243 1.792 1.894 0 3.242-1.263 3.242-3.089.034-1.518-.597-2.2-2.68-2.969ZM18.84 4.983c0 2.765 2.167 4.898 4.948 4.898.785 0 1.468-.154 2.287-.546v-2.15c-.734.733-1.382 1.024-2.201 1.024-1.843 0-3.157-1.332-3.157-3.243 0-1.809 1.348-3.225 3.071-3.225.87 0 1.536.307 2.287 1.058V.649c-.802-.41-1.468-.58-2.253-.58-2.747 0-4.983 2.184-4.983 4.914ZM40.614 6.587 38.106.273h-1.997l3.976 9.625h.99L45.119.273h-1.98l-2.525 6.314ZM45.956 9.66h5.187V8.071h-3.361V5.546h3.242V3.96h-3.242V1.878h3.361V.273h-5.187V9.66ZM58.396 3.054c0-1.757-1.212-2.764-3.328-2.764h-2.713v9.386h1.826V5.904h.239l2.525 3.772h2.253l-2.952-3.96c1.382-.29 2.15-1.228 2.15-2.662ZM54.71 4.607h-.53v-2.85h.564c1.143 0 1.758.478 1.758 1.4 0 .938-.615 1.45-1.792 1.45Z"
      fill="#231F20"
    />
    <path d="M31.689 10a5 5 0 1 0 0-10 5 5 0 0 0 0 10Z" fill="url(#grad)" />
    <path
      d="M59.557.632c0-.17-.12-.256-.307-.256h-.273v.82h.205V.87l.239.324h.239l-.273-.341c.102-.017.17-.103.17-.222Zm-.341.12h-.034V.53h.034c.102 0 .154.034.154.102 0 .085-.052.12-.154.12Z"
      fill="#231F20"
    />
    <path
      d="M59.284.069a.721.721 0 0 0-.717.716c0 .393.324.717.717.717A.721.721 0 0 0 60 .785a.721.721 0 0 0-.716-.716Zm0 1.314a.59.59 0 0 1-.58-.598.59.59 0 0 1 .58-.597c.307 0 .563.273.563.597 0 .325-.256.598-.563.598Z"
      fill="#231F20"
    />
    <defs>
      <linearGradient
        id="grad"
        x1="33.699"
        y1="8.928"
        x2="28.647"
        y2="-.945"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F58720" />
        <stop offset=".359" stopColor="#E16F27" />
        <stop offset=".703" stopColor="#D4602C" />
        <stop offset=".982" stopColor="#D05B2E" />
      </linearGradient>
    </defs>
  </svg>
);

export default Discover;
